/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import {
    Typography,
    TextField,
    Select,
    MenuItem,
    FormControl,
    FormHelperText
} from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { useZencity } from "./use-zencity";

const ZencityComponentEditor = () => {

    const { component, update } = useUpdateComponent();
    const { projects, getProject } = useZencity();
    const {
        project: _project = "",
        topic: _topic = "",
    } = component;

    const [project, setProject] = useState(_project);
    const [topic, setTopic] = useState(_topic);
    // const [projectDetail, setProjectDetail] = useState()
    const [engagements, setEngagements] = useState();
    
    const loadEngagements = async (id) => {
        const _project = await getProject(id);
        // const attributes = _project?.attributes
        const meta = _project?.meta;
        const engagements = meta?.associations_sort_order;
        // setProjectDetail(_project)
        setEngagements(engagements);
    };
    useEffect(() => {
        loadEngagements(project);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project]);
    
    // update from project text
    const onChangeProject = (event) => {
        const value = event.target.value;
        setProject(value);
        update("project", value);
    };
    // update from project select
    const selectProject = async (event) => {
        const id = event.target.value;
        setProject(id);
        update("project", `${id}`);
        loadEngagements(id);
    };
    const onChangeTopic = (event) => {
        const value = event.target.value;
        setTopic(value);
        update("topic", value);
    };
    const selectEngagement = async (event) => {
        const id = event.target.value;
        setTopic(id);
        update("topic", `${id}`);
    };
    
    return (
        <div className='simplicity-editor-frame' style={{ minHeight: "300px" }} >

            <div style={{
                border: "1px solid #cccccc", borderRadius: "4px",
                display: "flex", flexDirection: "column", gap: "4px",
                padding: "12px", margin: "16px 0",
            }}
            >
                <Typography variant='overline' color={"text.secondary"}>
                    Project
                </Typography>

                <div style={{
                    display: "flex", flexDirection: "row", gap: "16px",
                }}
                >
                    <div style={{ width: "100%" }}>
                        {projects &&
                            <FormControl style={{ width: "100%" }} >
                                <Select
                                    id="edit-category"
                                    name="edit-category"
                                    style={{ width: "100%" }}
                                    variant='outlined'
                                    className="form-select"
                                    value={project}
                                    displayEmpty
                                    onChange={(event) => selectProject(event,)}
                                >
                                    <MenuItem value=''>Select...</MenuItem>
                                    {projects?.map((project) => {
                                        return (
                                            <MenuItem
                                                key={project.id}
                                                value={project?.id}
                                                style={{ borderBottom: "1px solid grey", }}
                                            >
                                                <div style={{ padding: "4px 0", width: "100%", display: "flex" }}>
                                                    <div style={{ width: "50px" }}>{project?.id}</div>
                                                    <div style={{ fontWeight: "700" }}>{project?.project_title}</div>
                                                </div>
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                                <FormHelperText>Select a project.</FormHelperText>
                            </FormControl>
                        }
                    </div>
                    <div style={{ width: "160px" }}>
                        <TextField
                            id='project'
                            fullWidth={true}
                            value={project}
                            onChange={onChangeProject}
                        />
                    </div>
                </div>

                <Typography
                    style={{ marginTop: "24px" }}
                    variant='overline' color={"text.secondary"}
                >
                    Topic:
                </Typography>
                {project &&
                    <>
                        <div style={{
                            display: "flex", flexDirection: "row", gap: "16px",
                        }}
                        >
                            <div style={{ width: "100%" }}>
                                {engagements &&
                                    <FormControl style={{ width: "100%" }} >
                                        <Select
                                            id="edit-category"
                                            name="category"
                                            style={{ width: "100%" }}
                                            fullWidth={true}
                                            variant='outlined'
                                            className="form-select"
                                            value={topic}
                                            displayEmpty
                                            onChange={(event) => selectEngagement(event)}
                                        >
                                            <MenuItem value=''>Select...</MenuItem>
                                            {engagements?.map((engagement) => {
                                                return (
                                                    <MenuItem
                                                        key={engagement.id}
                                                        value={engagement?.id}
                                                    >
                                                        <div style={{ padding: "4px 0", width: "100%", display: "flex" }}>
                                                            <div style={{ width: "50px" }}>{engagement?.id}</div>
                                                            <div style={{ fontWeight: "700" }}>{engagement?.type}</div>
                                                        </div>
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                        <FormHelperText>Select a topic.</FormHelperText>
                                    </FormControl>
                                }
                            </div>
                            <div style={{ width: "160px" }}>
                                <TextField
                                    id='topic'
                                    fullWidth={true}
                                    value={topic}
                                    onChange={onChangeTopic}
                                    // disabled={true}
                                />
                            </div>
                        </div>
                    </>
                }
                {/*<p>Project: {`${project}`}</p>*/}
                {/*<p>has Project: {`${hasProject}`}</p>*/}
                {/*<p>Topic: {`${topic}`}</p>*/}
                {/*<p>has Topic: {`${hasTopic}`}</p>*/}
                {/*<p>matches: {`${topicMatchesOption}`}</p>*/}
            </div>
            {/*<pre>GUID: {JSON.stringify(component,null,2)}</pre>*/}
            {/*<pre>{JSON.stringify(projects,null,2)}</pre>*/}
            {/*<pre>{JSON.stringify(projectDetail,null,2)}</pre>*/}
            {/*<pre>{JSON.stringify(engagements,null,2)}</pre>*/}

        </div>
    );
};

ZencityComponentEditor.displayName = "CivilspaceComponentEditor";
export { ZencityComponentEditor };
